"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAsJsonOrString = void 0;
const misc_1 = require("@lit-protocol/misc");
/**
 * Parses a response string into a JS object.
 *
 * @param responseString - The response string to parse.
 * @returns The parsed response object.
 */
const parseAsJsonOrString = (responseString) => {
    try {
        return JSON.parse(responseString);
    }
    catch (e) {
        (0, misc_1.log)('[parseResponses] Error parsing response as json.  Swallowing and returning as string.', responseString);
        return responseString;
    }
};
exports.parseAsJsonOrString = parseAsJsonOrString;
//# sourceMappingURL=parse-as-json-or-string.js.map